module.exports = __webpack_public_path__ + "static/media/mum-kids.3bd7aa69.png";